<template v-once>
  <img src="@/assets/icons/rocket_blue.svg" alt="rocket icon">
</template>

<script>
export default {
name: "RocketBlue"
}
</script>

<style scoped>
</style>
